import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HeartHandshake, Coins } from "lucide-react";
import api, { fileUrl } from "../lib/api";

export default function SupporterWall({ userId, refreshKey }) {
  const [data, setData] = useState({ supporters: [], anonymous: { count: 0, total: 0 }, count: 0 });

  useEffect(() => {
    api.get(`/profiles/${userId}/supporters`).then((r) => setData(r.data)).catch(() => {});
  }, [userId, refreshKey]);

  const anon = data.anonymous || { count: 0, total: 0 };
  if (data.count === 0) return null;

  return (
    <div data-testid="supporter-wall" className="bg-card rounded-2xl border border-border p-5 mt-4">
      <div className="flex items-center gap-2 mb-3">
        <HeartHandshake className="w-5 h-5 text-copper" />
        <h3 className="font-serif text-lg font-semibold text-bronze">Supported by {data.count} kind {data.count === 1 ? "person" : "people"}</h3>
      </div>
      <div className="flex flex-wrap gap-3">
        {data.supporters.slice(0, 18).map((s) => (
          <Link key={s.user_id} to={`/u/${s.user_id}`} data-testid={`supporter-${s.user_id}`}
            className="flex flex-col items-center w-16 group" title={s.name}>
            <div className="relative">
              <img src={fileUrl(s.avatar_url) || `https://api.dicebear.com/7.x/lorelei/svg?seed=${s.user_id}`}
                alt={s.name} className="w-12 h-12 rounded-full object-cover bg-secondary group-hover:ring-2 ring-copper transition-all" />
              {s.tipped > 0 && (
                <span className="absolute -bottom-1 -right-1 bg-penny text-white rounded-full p-0.5" title={`Tipped $${s.tipped.toFixed(2)}`}>
                  <Coins className="w-3 h-3" />
                </span>
              )}
            </div>
            <span className="text-[11px] text-muted-foreground mt-1 truncate w-full text-center">{s.name?.split(" ")[0]}</span>
          </Link>
        ))}
        {anon.count > 0 && (
          <div data-testid="supporter-anonymous" className="flex flex-col items-center w-16" title={`${anon.count} anonymous ${anon.count === 1 ? "gift" : "gifts"} · $${anon.total.toFixed(2)}`}>
            <div className="w-12 h-12 rounded-full bg-secondary flex items-center justify-center text-copper"><HeartHandshake className="w-5 h-5" /></div>
            <span className="text-[11px] text-muted-foreground mt-1 text-center">{anon.count} anon</span>
          </div>
        )}
      </div>
    </div>
  );
}
